/**
 *  IMPORTANT: This file is used by the internal build
 *  script `extract-intl`, and must use CommonJS module syntax
 *  You CANNOT use import/export in this file.
 */

const DEFAULT_LOCALE = 'en';

// prettier-ignore
const appLocales = [
  'en',
  'fr',
];

exports.appLocales = appLocales;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
